import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.define-property";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { AnyColor, MainColor } from '../types/color';
import { BOLD, MEDIUM } from './text';
import { Color as ButtonColor, Variant } from '../types/button';
import { colorsRefresh } from './colors';
import { cornerRadii, cornerRadiiRefresh } from './corner-radii';
import { css } from 'styled-components';
import { Color as LoadingSpinnerColor } from '../core/indicators/LoadingSpinner/types';
import { strokeWidths, strokeWidthsRefresh } from './stroke-widths';
import Color from 'color';
import devError from '../utilities/dev-error';
import units from './units';

var getBackgroundColor = function getBackgroundColor(colorName, colors, _mainColor, _variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  switch (colorName) {
    case ButtonColor.Primary:
    case ButtonColor.Secondary:
    case ButtonColor.Blue:
      return colors[AnyColor.Primary];

    case ButtonColor.Tertiary:
      return colors[AnyColor.Gray4];

    case ButtonColor.Pagination:
      return colors[AnyColor.Light];

    case ButtonColor.PaginationActive:
      return colors[AnyColor.Highlight];

    case ButtonColor.TertiaryInverse:
      return colors[AnyColor.Transparent];

    default:
      return colors[colorName];
  }
};

var getBackgroundColorRefresh = function getBackgroundColorRefresh(colorName, colors, mainColor, variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  if (!variant) {
    if (mainColor === MainColor.Brand) {
      switch (colorName) {
        case ButtonColor.Primary:
        case ButtonColor.Secondary:
        case ButtonColor.Blue:
          return colors[AnyColor.Brand];

        case ButtonColor.Tertiary:
          return colors[AnyColor.BrandLight];

        case ButtonColor.TertiaryInverse:
        case ButtonColor.White:
        case ButtonColor.Pagination:
          return colors[AnyColor.Light];

        case ButtonColor.PaginationActive:
          return colors[AnyColor.SystemLight];

        default:
          var color = colors[colorName];

          if (typeof color !== 'string') {
            devError("Type " + typeof color + " is not a supported background color: " + color);
          }

          return color;
      }
    } else {
      switch (colorName) {
        case ButtonColor.Primary:
        case ButtonColor.Secondary:
        case ButtonColor.Blue:
          return colors[AnyColor.System];

        case ButtonColor.Tertiary:
          return colors[AnyColor.SystemLight];

        case ButtonColor.TertiaryInverse:
        case ButtonColor.White:
          return colors[AnyColor.Light];

        case ButtonColor.Pagination:
          return colors[AnyColor.Light];

        case ButtonColor.PaginationActive:
          return colors[AnyColor.SystemLight];

        default:
          var color = colors[colorName];

          if (typeof color !== 'string') {
            devError("Type " + typeof color + " is not a supported background color: " + color);
          }

          return color;
      }
    }
  } else {
    if (mainColor === MainColor.Brand) {
      switch (variant) {
        case Variant.Primary:
          return colors[AnyColor.Brand];

        case Variant.Secondary:
          return colors[AnyColor.BrandLight];

        case Variant.Light:
          return colors[AnyColor.Light];

        case Variant.Outline:
          return colors[AnyColor.Transparent];

        default:
          return colors[variant];
      }
    } else {
      switch (variant) {
        case Variant.Primary:
          return colors[AnyColor.System];

        case Variant.Secondary:
          return colors[AnyColor.SystemLight];

        case Variant.Light:
          return colors[AnyColor.Light];

        case Variant.Outline:
          return colors[AnyColor.Transparent];

        default:
          var color = colors[variant];

          if (typeof color !== 'string') {
            devError("Type " + typeof color + " is not a supported background color: " + color);
          }

          return color;
      }
    }
  }
};

var getBorderColor = function getBorderColor(colorName, colors) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  switch (colorName) {
    case ButtonColor.Pagination:
    case ButtonColor.PaginationActive:
      return colors[AnyColor.Gray4];

    case ButtonColor.TertiaryInverse:
      return colors[AnyColor.Light];

    default:
      return getBackgroundColor(colorName, colors);
  }
};

var getBorderStyle = function getBorderStyle(colorName, colors, _variant, _mainColor) {
  var borderColor = getBorderColor(colorName, colors);
  return strokeWidths["default"] + " solid " + borderColor;
};

var getBorderStyleRefresh = function getBorderStyleRefresh(colorName, colors, variant, mainColor) {
  switch (variant) {
    case Variant.Outline:
      return strokeWidthsRefresh["default"] + " solid " + colors[AnyColor.Gray3];

    default:
      return strokeWidthsRefresh["default"] + " solid " + getBackgroundColorRefresh(colorName, colors, mainColor, variant);
  }
};

var getTextColorName = function getTextColorName(colorName, _mainColor, _variant, _disabled) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  switch (colorName) {
    case ButtonColor.Tertiary:
      return AnyColor.Gray1;

    case ButtonColor.White:
    case ButtonColor.Light:
    case ButtonColor.Pagination:
    case ButtonColor.PaginationActive:
      return AnyColor.Dark;

    default:
      return AnyColor.Light;
  }
};

var getTextColorNameRefresh = function getTextColorNameRefresh(colorName, mainColor, variant, disabled) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  if (disabled) {
    return AnyColor.Gray3;
  }

  if (!variant) {
    if (mainColor === MainColor.Brand) {
      switch (colorName) {
        case ButtonColor.Primary:
        case ButtonColor.Secondary:
          return AnyColor.Light;

        case ButtonColor.Tertiary:
          return AnyColor.Brand;

        case ButtonColor.TertiaryInverse:
        case ButtonColor.White:
        case ButtonColor.Light:
        case ButtonColor.Pagination:
        case ButtonColor.PaginationActive:
          return AnyColor.Dark;

        default:
          return AnyColor.Light;
      }
    } else {
      switch (colorName) {
        case ButtonColor.Primary:
        case ButtonColor.Secondary:
          return AnyColor.Light;

        case ButtonColor.Tertiary:
          return AnyColor.System;

        case ButtonColor.TertiaryInverse:
        case ButtonColor.White:
        case ButtonColor.Light:
        case ButtonColor.Pagination:
        case ButtonColor.PaginationActive:
          return AnyColor.Dark;

        default:
          return AnyColor.Light;
      }
    }
  } else {
    if (mainColor === MainColor.Brand) {
      switch (variant) {
        case Variant.Secondary:
          return AnyColor.Brand;

        case Variant.Light:
        case Variant.Outline:
          return AnyColor.Dark;

        default:
          return AnyColor.Light;
      }
    } else {
      switch (variant) {
        case Variant.Secondary:
          return AnyColor.System;

        case Variant.Light:
        case Variant.Outline:
          return AnyColor.Dark;

        default:
          return AnyColor.Light;
      }
    }
  }
};

var getLoadingSpinnerColorName = function getLoadingSpinnerColorName(colorName, variant, disabled) {
  if (disabled) {
    return LoadingSpinnerColor.Gray3;
  }

  if (variant) {
    switch (variant) {
      case Variant.Light:
      case Variant.Outline:
        return LoadingSpinnerColor.Gray3;

      case Variant.Secondary:
        return LoadingSpinnerColor.Primary;

      default:
        return LoadingSpinnerColor.Light;
    }
  }

  switch (colorName) {
    case ButtonColor.Tertiary:
      return LoadingSpinnerColor.Primary;

    case ButtonColor.White:
    case ButtonColor.Light:
    case ButtonColor.Pagination:
    case ButtonColor.PaginationActive:
      return LoadingSpinnerColor.Gray3;

    default:
      return LoadingSpinnerColor.Light;
  }
};

var getTextColor = function getTextColor(colorName, colors, mainColor, variant, _disabled) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  return colors[getTextColorName(colorName, mainColor, variant)];
};

var getTextColorRefresh = function getTextColorRefresh(colorName, colors, mainColor, variant, disabled) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  return colors[getTextColorNameRefresh(colorName, mainColor, variant, disabled)];
};

var getFocusStyles = function getFocusStyles(colors) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-shadow: 0 0 8px 0 ", ";\n    outline: none;\n"], ["\n    box-shadow: 0 0 8px 0 ", ";\n    outline: none;\n"])), colors[AnyColor.Secondary]);
};

var getFocusStylesRefresh = function getFocusStylesRefresh(colors) {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-shadow: 0 0 0.5rem\n        ", ";\n    outline: none;\n"], ["\n    box-shadow: 0 0 0.5rem\n        ", ";\n    outline: none;\n"])), Color(colors[AnyColor.Blue]).fade(0.7).hex());
};

var getHoverStyles = function getHoverStyles(colorName, colors, _mainColor, _variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  var lightenFactor;

  switch (colorName) {
    case ButtonColor.Pagination:
      var backgroundColor = Color(getBackgroundColor(ButtonColor.PaginationActive, colors)).lighten(0.02).hex();
      return "\n                background-color: " + backgroundColor + ";\n            ";

    case ButtonColor.PaginationActive:
      // We use pagination and pagination:active in our <Pagination> component
      // and our <ButtonGroup> component which is used for non paginated
      // things. Doing nothing here is better then the default case.
      return "";

    case ButtonColor.TertiaryInverse:
      return "\n                background-color: " + Color(getBorderColor(colorName, colors)).fade(0.8).string() + ";\n            ";

    case ButtonColor.Tertiary:
    case ButtonColor.White:
    case ButtonColor.Light:
      lightenFactor = 0.01;
      break;

    default:
      lightenFactor = 0.05;
      break;
  }

  var lightenedColor = Color(getBackgroundColor(colorName, colors)).lighten(lightenFactor).hex();
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0 ", "\n            ", ";\n    "], ["\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0 ", "\n            ", ";\n    "])), lightenedColor, lightenedColor, units.getValues([0.5, 1.5]), Color(colors[AnyColor.Dark]).fade(0.9).string());
};

var getHoverStylesRefresh = function getHoverStylesRefresh(colorName, colors, mainColor, variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  var hoverStyle;

  if (!variant) {
    switch (colorName) {
      case ButtonColor.Primary:
      case ButtonColor.Secondary:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.04).hex();
        break;

      case ButtonColor.Tertiary:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).saturate(0.05).darken(0.02).hex();
        break;

      case ButtonColor.TertiaryInverse:
      case ButtonColor.White:
      case ButtonColor.Light:
        hoverStyle = colors[AnyColor.Gray5];
        break;

      case ButtonColor.Pagination:
        hoverStyle = Color(getBackgroundColor(ButtonColor.PaginationActive, colors)).lighten(0.02).hex();
        break;

      case ButtonColor.PaginationActive:
        hoverStyle = '';
        break;

      default:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.04).hex();
        break;
    }
  } else {
    switch (variant) {
      case Variant.Primary:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.04).hex();
        break;

      case Variant.Secondary:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).saturate(0.05).darken(0.02).hex();
        break;

      case Variant.Light:
      case Variant.Outline:
        hoverStyle = colors[AnyColor.Gray5];
        break;

      default:
        hoverStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.04).hex();
        break;
    }
  }

  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: ", ";\n    "], ["\n        background-color: ", ";\n    "])), hoverStyle);
};

var getActiveStyles = function getActiveStyles(colorName, colors, _mainColor, _variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  switch (colorName) {
    case ButtonColor.Pagination:
    case ButtonColor.PaginationActive:
      return 'background-color: ' + colors[AnyColor.Highlight];

    default:
      return "\n                box-shadow: none;\n            ";
  }
};

var getActiveStylesRefresh = function getActiveStylesRefresh(colorName, colors, mainColor, variant) {
  if (colorName === void 0) {
    colorName = ButtonColor.Tertiary;
  }

  var activeStyle;

  if (!variant) {
    switch (colorName) {
      case ButtonColor.Primary:
      case ButtonColor.Secondary:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.08).hex();
        break;

      case ButtonColor.Tertiary:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).saturate(0.1).darken(0.04).hex();
        break;

      case ButtonColor.TertiaryInverse:
      case ButtonColor.White:
      case ButtonColor.Light:
        activeStyle = colors[AnyColor.Gray4];
        break;

      case ButtonColor.Pagination:
      case ButtonColor.PaginationActive:
        activeStyle = colors[AnyColor.SystemLight];
        break;

      default:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.08).hex();
        break;
    }
  } else {
    switch (variant) {
      case Variant.Primary:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.08).hex();
        break;

      case Variant.Secondary:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).saturate(0.1).darken(0.04).hex();
        break;

      case Variant.Light:
      case Variant.Outline:
        activeStyle = colors[AnyColor.Gray4];
        break;

      default:
        activeStyle = Color(getBackgroundColorRefresh(colorName, colors, mainColor, variant)).darken(0.08).hex();
        break;
    }
  }

  return "background-color: " + activeStyle;
};

var getAdditionalStyles = function getAdditionalStyles(colorName) {
  switch (colorName) {
    case ButtonColor.Pagination:
    case ButtonColor.PaginationActive:
      return "\n                min-width: " + units.getValue(5) + ";\n                border-left-width: 0;\n\n                &:first-child {\n                    border-left-width: " + strokeWidths["default"] + ";\n                }\n            ";

    default:
      return '';
  }
};

var disabledStyle = "opacity: 0.33;";
var disabledStyleRefresh = "\n    background-color: " + colorsRefresh.gray5 + ";\n    border-color: " + colorsRefresh.gray5 + ";\n    color: " + colorsRefresh.gray3 + " !important;\n";
export var buttons = Object.freeze({
  cornerRadii: cornerRadii["default"],
  fontWeight: BOLD,
  getActiveStyles: getActiveStyles,
  getBackgroundColor: getBackgroundColor,
  getBorderStyle: getBorderStyle,
  disabledStyle: disabledStyle,
  getTextColor: getTextColor,
  getTextColorName: getTextColorName,
  getLoadingSpinnerColorName: getLoadingSpinnerColorName,
  getFocusStyles: getFocusStyles,
  getHoverStyles: getHoverStyles,
  getAdditionalStyles: getAdditionalStyles,
  padding: {
    xs: [0.5, 1],
    sm: [1, 1.5],
    mdsm: [1.5, 2],
    md: [2, 3],
    lg: [3, 4]
  },
  textSize: {
    xs: 0,
    sm: 0,
    mdsm: 1,
    md: 1,
    lg: 1
  },
  textTransform: 'uppercase'
});
export var buttonsRefresh = Object.freeze({
  cornerRadii: cornerRadiiRefresh.circle,
  fontWeight: MEDIUM,
  getActiveStyles: getActiveStylesRefresh,
  getBackgroundColor: getBackgroundColorRefresh,
  getBorderStyle: getBorderStyleRefresh,
  disabledStyle: disabledStyleRefresh,
  getTextColor: getTextColorRefresh,
  getTextColorName: getTextColorNameRefresh,
  getLoadingSpinnerColorName: getLoadingSpinnerColorName,
  getFocusStyles: getFocusStylesRefresh,
  getHoverStyles: getHoverStylesRefresh,
  getAdditionalStyles: getAdditionalStyles,
  // Special padding values are required to achieve specific button heights
  padding: {
    xs: [0.5, 1],
    sm: [0.9375, 2],
    mdsm: [1.5, 2],
    md: [1.5625, 3],
    lg: [3, 4]
  },
  textSize: {
    xs: 0,
    sm: 0,
    mdsm: 1,
    md: 1,
    lg: 1
  },
  textTransform: 'none'
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;